import { parseParamsForURL } from 'services/utils/urlParams';
import http from 'services/utils/http';
import { subscribeToAngularEvent } from 'services/utils/angularUtils';

const apiName = 'mediationApp';
const baseUrl = '/api/rest/v1/partners/mediationApplications';

const formatData = (data) => {
    const res = data.slice();
    const map = res.reduce((acc, application) => {
        acc[application.id] = { ...application };
        acc[application.id].active = acc[application.id].active || {};
        if (application.active) {
            acc[application.id].isAnyActive = Object.values(application.active)
                .some((value) => value);
        }
        if (application.hasManual) {
            acc[application.id].isAnyManual = Object.values(application.hasManual)
                .some((value) => value);
        }
        Object.keys(acc[application.id].configurations).forEach((adUnit) => {
            const adUnitsConfig = acc[application.id].configurations[adUnit];
            Object.keys(adUnitsConfig)
                .map((instanceId) => {
                    const instanceConfigs = adUnitsConfig[instanceId];
                    if (instanceConfigs) {
                        instanceConfigs.key = instanceId;
                    }
                    const instance = acc[application.id];
                    if (instance.id === instanceConfigs.key && adUnit === instance.deliveryType) {
                        instanceConfigs.name = instance.name;
                        instanceConfigs.rate = instance.rate;
                    };
                    return instanceConfigs;
                });
        });
        return acc;
    }, {});
    return { map };
};

export default {
    namespaced: true,
    state: {
        list: null,
        error: undefined,
        loading: true,
        subscribedToClearCacheEvent: false
    },
    mutations: {
        setLoading(state, isLoading) {
            state.loading = isLoading;
        },
        setMediationApps(state, apps) {
            state.list = apps;
            state.loading = false;
        },
        setError(state, error) {
            state.error = error;
        },
        setSubscribedToClearCacheEvent(state, subscribedToClearCacheEvent) {
            state.subscribedToClearCacheEvent = subscribedToClearCacheEvent;
        }
    },
    actions: {
        async fetch({ state, commit, rootGetters }, {
            refresh = false,
            filters = {}
        } = {}) {
            const params = parseParamsForURL(filters);
            const apiUrl = `${baseUrl}?${params}`;

            if (!state.subscribedToClearCacheEvent) {
                subscribeToAngularEvent('mediationApplicationsClearCache', () => {
                    commit('cache/clearCache', { api: apiName }, { root: true });
                });
                commit('setSubscribedToClearCacheEvent', true);
            }

            if (!refresh) {
                const cachedResult = rootGetters['cache/getFromCache'](apiName, apiUrl);
                if (cachedResult) {
                    commit('setError', undefined);
                    commit('setMediationApps', cachedResult);
                    return;
                }
            }

            try {
                commit('setLoading', true);
                const resData = await http.get(apiUrl);
                const res = formatData(resData.data);
                commit('cache/set', {
                    api: apiName,
                    req: apiUrl,
                    data: res
                }, { root: true });
                commit('setMediationApps', res);
                commit('setError', undefined);
            } catch (err) {
                commit('setError', err.message);
            } finally {
                commit('setLoading', false);
            }
        }
    },
    getters: {
        getMediationApplications: (state) => state.list,
        getAppsLoading: (state) => state.loading
    }
};
